module.exports = __webpack_public_path__ + "static/media/Sudoku.9a135528.PNG";